import { Mail, Linkedin, Github, Code2 } from "lucide-react";
import { useApp } from "../context/AppContext";
import { contactLinks } from "../data/content";

export default function Footer() {
  const { t } = useApp();

  const socials = [
    { icon: Github, href: contactLinks.github, label: "GitHub" },
    { icon: Linkedin, href: contactLinks.linkedin, label: "LinkedIn" },
    { icon: Mail, href: `mailto:${contactLinks.email}`, label: "Email" },
  ];

  return (
    <footer className="border-t border-soft">
      <div className="mx-auto flex max-w-6xl flex-col items-center justify-between gap-6 px-5 py-10 sm:flex-row sm:px-8">
        <div className="flex flex-col items-center gap-2 sm:items-start">
          <a href="#home" className="flex items-center gap-2">
            <span className="grid h-8 w-8 place-items-center rounded-lg bg-gradient-to-br from-cyan-400 to-purple-500 text-slate-950">
              <Code2 className="h-4 w-4" strokeWidth={2.4} />
            </span>
            <span className="font-display font-bold">
              Daniel<span className="gradient-text">Camacho</span>
            </span>
          </a>
          <p className="text-center text-xs text-soft sm:text-left">{t("footer.built")}</p>
        </div>

        <div className="flex items-center gap-3">
          {socials.map((s) => (
            <a
              key={s.label}
              href={s.href}
              aria-label={s.label}
              {...(s.href.startsWith("http") ? { target: "_blank", rel: "noopener noreferrer" } : {})}
              className="grid h-10 w-10 place-items-center rounded-xl border border-soft card-bg text-soft transition-all hover:-translate-y-0.5 hover:border-cyan-400/50 hover:text-cyan-400"
            >
              <s.icon className="h-4 w-4" />
            </a>
          ))}
        </div>
      </div>
      <div className="border-t border-soft py-4">
        <p className="text-center text-xs text-soft">{t("footer.rights")}</p>
      </div>
    </footer>
  );
}
